<template>
  <div>
    <v-row>
      <v-col cols="12">
        <GradeClassStudentSelect ref="gcsSelect" :studentRules="[$rules.required]" @changed="gradeClassStudentChange" />
      </v-col>
    </v-row>
    <v-row class="mt-3" justify="space-between">
      <v-col cols="12" md="10">
        <RadioSemester :schoolYear="currentSchoolYear" @change="onRadioSemesterChange" />
      </v-col>
      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn :disabled="filterButtonDisable" color="primary" @click="onFilterChanged">
          Xem điểm
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import { Student } from '@/plugins/api'
import RadioSemester from '@/components/basic/input/RadioSemester'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    RadioSemester,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: null,
    semesterData: ''
  }),
  props: {
    defaultStudentId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('app', ['currentSchoolYear']),
    filterButtonDisable() {
      return get(this.selectedStudent, 'id', '') === ''
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },
    onRadioSemesterChange(semester) {
      this.semesterData = semester
    },
    onFilterChanged() {
      if (!this.$refs['gcsSelect'].validate()) {
        return
      }
      let semesterList = []
      if (this.semesterData.type === 'year') {
        semesterList = [...this.semesterData.semesters]
      } else {
        semesterList.push(this.semesterData)
      }
      this.$emit('onFilterChanged', {
        grade: this.selectedGrade,
        class: this.selectedClass,
        student: this.selectedStudent,
        semesters: semesterList
      })
    }
  },
  watch: {
    async defaultStudentId(newValue) {
      if (newValue) {
        const student = await Student.fetchOne(newValue)
        this.selectedStudent = student
        this.selectedClass = student.currentClass
        this.selectedGrade = student.grade
        this.onFilterChanged()
      }
    }
  }
}
</script>
